var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404NotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "748.974px",
    height: "457.275px",
    viewBox: "0 0 748.974 457.275",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    transform: "translate(-382.003 -195.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    transform: "translate(382.003 195.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3120-1155",
    d: "M695.225,508.82,433.394,576.244a34.622,34.622,0,0,1-42.114-24.866L312.1,243.879a34.622,34.622,0,0,1,24.866-42.114l243.591-62.727L642.9,166.948l77.191,299.757A34.622,34.622,0,0,1,695.225,508.82Z",
    transform: "translate(-311.003 -139.037)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121-1156",
    d: "M338.989,210.925a24.655,24.655,0,0,0-17.708,29.99l79.185,307.5a24.655,24.655,0,0,0,29.99,17.708L692.287,498.7a24.655,24.655,0,0,0,17.708-29.99L634,173.595l-54.792-24.529Z",
    transform: "translate(-310.548 -138.556)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122-1157",
    d: "M629.927,168.5l-40.522,10.435a11.518,11.518,0,0,1-14.026-8.282l-7.707-29.929a.72.72,0,0,1,.989-.837l61.379,27.258a.72.72,0,0,1-.113,1.355Z",
    transform: "translate(-298.695 -139)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123-1158",
    d: "M612.519,418.284l-119.208,30.7a5.759,5.759,0,0,1-2.872-11.154l119.208-30.7a5.759,5.759,0,1,1,2.872,11.154Z",
    transform: "translate(-302.605 -126.189)",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124-1159",
    d: "M640.149,430.592,497.936,467.214a5.759,5.759,0,1,1-2.872-11.154l142.213-36.622a5.759,5.759,0,0,1,2.872,11.154Z",
    transform: "translate(-302.384 -125.599)",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    cx: 20.355,
    cy: 20.355,
    r: 20.355,
    transform: "translate(121.697 319.055)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125-1160",
    d: "M604.421,374.437,446.1,415.191a17.835,17.835,0,0,1-21.694-12.812L391.229,273.49A17.835,17.835,0,0,1,404.041,251.8l158.32-40.754a17.835,17.835,0,0,1,21.694,12.812l33.178,128.889A17.835,17.835,0,0,1,604.421,374.437Z",
    transform: "translate(-307.183 -135.611)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126-1161",
    d: "M604.421,374.437,446.1,415.191a17.835,17.835,0,0,1-21.694-12.812L391.229,273.49A17.835,17.835,0,0,1,404.041,251.8l158.32-40.754a17.835,17.835,0,0,1,21.694,12.812l33.178,128.889A17.835,17.835,0,0,1,604.421,374.437ZM404.563,253.826a15.737,15.737,0,0,0-11.3,19.142l33.178,128.889a15.737,15.737,0,0,0,19.142,11.3L603.9,372.407a15.737,15.737,0,0,0,11.3-19.142L582.025,224.376a15.737,15.737,0,0,0-19.142-11.3Z",
    transform: "translate(-307.183 -135.611)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411-1162",
    d: "M550.66,252.63l-79.9,20.568a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l81.335-20.937c3.286,1.665,2.421,5.07.091,5.67Z",
    transform: "translate(-303.514 -133.861)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412-1163",
    d: "M554.1,266l-79.9,20.568a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l81.335-20.937c3.286,1.665,2.421,5.07.091,5.67Z",
    transform: "translate(-303.349 -133.22)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413-1164",
    d: "M461.146,298.825,436.761,305.1a3.1,3.1,0,0,1-3.776-2.23L425.577,274.1a3.1,3.1,0,0,1,2.23-3.776l24.385-6.277a3.105,3.105,0,0,1,3.776,2.23l7.408,28.777a3.1,3.1,0,0,1-2.23,3.776Z",
    transform: "translate(-305.513 -133.047)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414-1165",
    d: "M562.854,293.445,440.909,324.835a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76c3.286,1.665,2.421,5.07.091,5.67Z",
    transform: "translate(-304.946 -131.904)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415-1166",
    d: "M566.3,306.822,444.353,338.213a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76c3.286,1.665,2.421,5.07.091,5.67Z",
    transform: "translate(-304.781 -131.263)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416-1167",
    d: "M569.739,320.192,447.794,351.582a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.379-31.76c3.286,1.665,2.421,5.07.091,5.67Z",
    transform: "translate(-304.616 -130.621)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417-1168",
    d: "M573.183,333.569,451.237,364.959a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76C576.377,329.564,575.513,332.969,573.183,333.569Z",
    transform: "translate(-304.45 -129.98)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418-1169",
    d: "M576.624,346.939,454.679,378.329a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76C579.819,342.934,578.954,346.339,576.624,346.939Z",
    transform: "translate(-304.285 -129.339)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395-1170",
    d: "M448.363,470.511a2.111,2.111,0,0,1-1.335-.092l-.026-.011-5.545-2.351a2.126,2.126,0,1,1,1.664-3.913l3.593,1.528,4.708-11.076a2.125,2.125,0,0,1,2.787-1.124h0l-.028.072.029-.073a2.127,2.127,0,0,1,1.124,2.788l-5.539,13.023a2.126,2.126,0,0,1-1.431,1.224Z",
    transform: "translate(-304.809 -123.966)",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    transform: "translate(673.007 225.872) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    transform: "translate(125.896 0) rotate(19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3127-1171",
    d: "M304.956,386.7H34.583A34.622,34.622,0,0,1,0,352.114V34.583A34.622,34.622,0,0,1,34.583,0H286.121l53.418,42.577V352.114A34.622,34.622,0,0,1,304.956,386.7Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128-1172",
    d: "M24.627,0A24.655,24.655,0,0,0,0,24.627V342.158a24.655,24.655,0,0,0,24.627,24.627H295a24.655,24.655,0,0,0,24.627-24.627V37.418L272.683,0Z",
    transform: "translate(9.956 9.956)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129-1173",
    d: "M128.856,11.518H5.759A5.759,5.759,0,0,1,5.759,0h123.1a5.759,5.759,0,0,1,0,11.518Z",
    transform: "translate(123.512 90.767)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130-1174",
    d: "M152.612,11.518H5.759A5.759,5.759,0,0,1,5.759,0H152.612a5.759,5.759,0,1,1,0,11.518Z",
    transform: "translate(123.512 110.204)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131-1175",
    d: "M128.852,0H5.758a5.758,5.758,0,1,0,0,11.517H128.852a5.759,5.759,0,0,0,0-11.517Z",
    transform: "translate(123.517 177.868)",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132-1176",
    d: "M152.609,0H5.758a5.759,5.759,0,1,0,0,11.517h146.85a5.759,5.759,0,1,0,0-11.517Z",
    transform: "translate(123.517 197.307)",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133-1177",
    d: "M128.856,11.518H5.759A5.759,5.759,0,0,1,5.759,0h123.1a5.759,5.759,0,0,1,0,11.518Z",
    transform: "translate(123.512 264.975)",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134-1178",
    d: "M152.612,11.518H5.759A5.759,5.759,0,0,1,5.759,0H152.612a5.759,5.759,0,1,1,0,11.518Z",
    transform: "translate(123.512 284.411)",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-2",
    cx: 20.355,
    cy: 20.355,
    r: 20.355,
    transform: "translate(57.655 85.89)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395-2-1179",
    d: "M6.909,15.481a2.111,2.111,0,0,1-1.27-.422l-.023-.017L.832,11.382A2.126,2.126,0,0,1,3.419,8.008l3.1,2.376L13.839.832A2.125,2.125,0,0,1,16.819.439h0L16.774.5l.047-.063a2.127,2.127,0,0,1,.393,2.98L8.6,14.649a2.126,2.126,0,0,1-1.691.829Z",
    transform: "translate(69.085 98.528)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135-1180",
    d: "M40.707,20.359A20.354,20.354,0,0,1,20.356,40.721a4.372,4.372,0,0,1-.524-.021A20.353,20.353,0,1,1,40.707,20.359Z",
    transform: "translate(59.75 172.987)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-3",
    cx: 20.355,
    cy: 20.355,
    r: 20.355,
    transform: "translate(57.655 260.097)",
    fill: "#708090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136-1181",
    d: "M53.362,43.143H11.518A11.518,11.518,0,0,1,0,31.625V.72A.72.72,0,0,1,1.167.156l52.642,41.7a.72.72,0,0,1-.447,1.284Z",
    transform: "translate(285.137 0.805)",
    fill: "#cccccc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140-1182",
    d: "M754.518,518.049a9.158,9.158,0,0,1-12.587,3.05L635.078,455.923a9.158,9.158,0,0,1,9.538-15.637l106.852,65.176a9.158,9.158,0,0,1,3.049,12.587Z",
    transform: "translate(123.58 101.359)",
    fill: "#8D9AA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141-1183",
    d: "M688.648,486.5a73.265,73.265,0,1,1-24.4-100.7A73.265,73.265,0,0,1,688.648,486.5ZM579.19,419.73a54.949,54.949,0,1,0,75.524-18.3,54.949,54.949,0,0,0-75.524,18.3Z",
    transform: "translate(82.597 67.737)",
    fill: "#8D9AA6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-4",
    cx: 57.007,
    cy: 57.007,
    r: 57.007,
    transform: "translate(672.542 442.858) rotate(19)",
    fill: "#708090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404NotFound);
export default __webpack_public_path__ + "static/media/404_not_found.9c19b4515df946a194e3fc2f5efc3157.svg";
export { ForwardRef as ReactComponent };